{
  "nl": {
    "inspiration": {
      "actions": {
        "delete": "Verwijderen",
        "deleteMultipleInspirations": "Verwijder...",
        "delete_cancel": "Annuleren",
        "goBackToInspirationLists": "Inspiraties",
        "new": "Voeg foto toe"
      },
      "labels": {
        "move_to_upload": "Sleep je document naar het vak hieronder of klik erop om te uploaden.",
        "noInspirations": "Nog geen inspiraties",
        "upload_autoclose": "Dit venster sluit automatisch wanneer alle bestanden geüpload zijn."
      },
      "toasts": {
        "upload_success": "{count} inspiratie succesvol geüpload | {count} inspiraties succesvol geüpload"
      }
    }
  }
}
